import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import GmtToLocal from "./GmtToLocal";
import dayjs from "dayjs";
import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";
import DOMPurify from 'dompurify';

import {
  fetchAlarmsDeviceEndPoint,
  fetchAlarmsListEndPoint,
  fetchv1DeviceDetailsEndPoint,
  fetchV1DeviceEndPoint,
  createUserEndPoint,
  updateUserEndPoint,
  createRolesEndPoint,
  updateRoleEndPoint,
  createOrganizationEndPoint,
  updateOrganizationEndPoint,
  updateDeviceEndPoint,
  updateSmartAlertEndPoint,
  fetchLocationHistorymapEndPoint,
  fetchassetCountEndPoint,
  fetchLostCountEndPoint,
  fetchProdCountEndPoint,
  fetchLocationAlertsEndPoint,
  validateRolesName,
} from "../../configuration";
import {
  createLocationEndPoint,
  updateLocationEndPoint,
  fetchOrganizationEndPoint,
  fetchMyprofileEndPoint,
  fetchLocationEndPoint,
  fetchLatLongEndPoint,
  fetchRolesEndPoint,
  fetchassetmapEndPoint,
  fetchDeviceValEndPoint,
  setupUserEndPoint,
  fetchallassetCountEndPoint,
  validateAlertsGroupName,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

export function isItGateway(device) {
  return device?.parentdeviceid ? false : true;
}

export const deviceHashMap = {
  "ts.device.gateway": "Gateways",
  "ts.device.gatewayChild": "Gateway Child Devices",
  "ts.device.tgAssetTracker": "GAT Devices",
  "ts.device.cHeAssetTracker": "Cat/Cas Devices",
  "ts.device.smartcam": "Smart Cameras",
  "ts.device.pushcam": "Push Cam Devices",
  "ts.device.dmp": "Dmp Devices",
  "ts.device.onvif": "Onvif Devices",
};

export const fetcher = (url) => fetch(url).then((r) => r.json());
export const fetcherForFunction = (funct) => funct.then((r) => r);
export function celsiusToFahrenheit(celsius) {
  return (celsius * 9) / 5 + 32;
}
export function celsiusToFahrenheitRounded(celsius) {
  return Math.round((celsius * 9/5) + 32);
}

  export function calculateRms (valX, valY, valZ) {
    const xSquared = valX * valX;
    const ySquared = valY * valY;
    const zSquared = valZ * valZ;
    const meanSquared = (xSquared + ySquared + zSquared) / 3;
    const rms = Math.sqrt(meanSquared);
    return rms.toFixed(4); 
  };
// This logic here may need to be re-visited
export function prepareDataForPieChart(deviceList) {
  let pieData = [];
  if (!deviceList || !deviceList.length > 0) return [];
  console.log("deviceList before groupBy function", deviceList);
  let groupData = groupBy(deviceList, "state");
  console.log("deviceList after groupBy function", groupData);

  let groupedData = [];

  for (const key in groupData) {
    let name = key;
    if (isItGateway(groupData[key][0].kind)) {
      if (key === "ready") name = "Active";
      else if (key === "registered") name = "Pending Activation";
    } else {
      if (key.toLowerCase() === "registered" || key.toLowerCase() === "ready")
        name = "Active";
    }
    if (!groupedData[name]) {
      groupedData[name] = groupData[key];
    } else {
      groupedData[name] = [...groupedData[name], ...groupData[key]];
    }
  }
  // Checking for
  for (const key in groupedData) {
    //console.log("key in second for loop", key)
    pieData.push({
      id: key,
      value: groupedData[key].length,
      label: `${key} : ${groupedData[key].length}`, //Here is where the Active:9 is at
      component: groupedData[key],
      isGateway: isItGateway(groupedData[key][0].kind),
    });
  }

  return pieData;
}

export let groupBy = function (xs, key) {
  // console.log(xs, key);
  if (xs) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  } else {
  }
};

function getLabel(groupedData, key) {}

function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function buildChildren(deviceList) {
  let dmpList = [];
  let gatewayList = [];
  let gatGatewayList = [];
  for (let j = 0; j < deviceList.length; j++) {
    if (deviceList[j].kind === "ts.device.dmp") dmpList.push(deviceList[j].id);
    if (deviceList[j].kind === "ts.device.gateway")
      gatewayList.push(deviceList[j].id);
    if (deviceList[j].kind === "ts.device.tgAssetTracker")
      gatGatewayList.push(deviceList[j].id);
  }

  for (let j = 0; j < deviceList.length; j++) {
    if (
      deviceList[j].trustee &&
      (dmpList.includes(deviceList[j].trustee) ||
        gatewayList.includes(deviceList[j].trustee) ||
        gatGatewayList.includes(deviceList[j].trustee))
    ) {
      for (let k = 0; k < deviceList.length; k++) {
        if (deviceList[j].trustee === deviceList[k].id) {
          deviceList[j].isChild = true;
          if (deviceList[k].children) {
            deviceList[k].children.push(deviceList[j]);
          } else {
            deviceList[k].children = [deviceList[j]];
          }
        }
      }
    }
  }
}

export function getImageByType(device) {
  //returns the image url for the given type
  let parentDevice = getParentDevice(device);
  let parentType = parentDevice["kind"];
  console.log("parent", parentType);
  console.log("sensor device", device);

  if (isItGateway(device)) {
    switch (true) {
      case device["kind"] === "ts.device.tgAssetTracker":
        return (
          <image
            src="https://thingspace.verizon.com/content/dam/thingspace-portal/solutions/critical-asset-sensor/CritialAssetSensor-graphic.svg"
            alt="Asset Tracking Gateway"
          />
        );
      case device["kind"] === "ts.device.gateway.iokey.ifm":
        return (
          <image
            src="https://media.ifm.com/CIP/mediadelivery/rendition/cefe6d4ab9fa8a47a52e222751860e4a/-B900-FJPG/AIK050"
            alt="io_link Gateway"
          />
        );
      case device["kind"] === "ts.device.gateway.lorawan.multitech":
        return (
          <image
            src="https://www.multitech.com/documents/media/images/products/multiconnect/conduit/MT_Conduit_AEP_clear_hr1000px_8-2019.png"
            alt="lorawan Gateway"
          />
        );
      default:
        return (
          <image
            src="https://www.multitech.com/documents/media/images/products/multiconnect/conduit/MT_Conduit_AEP_clear_hr1000px_8-2019.png"
            alt="Gateway"
          />
        );
    }
  } else {
    switch (true) {
      case device["kind"] === "ts.device.ble" ||
        parentDevice["kind"] === "ts.device.tgAssetTracker" ||
        device["name"].includes("ble"):
        return (
          <image
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFQ49CmXPVFNePMSrHNj0_GNEtALMlZyuNFQ&usqp=CAU"
            alt="ble Sensor"
          />
        );
      case parentType === "ts.device.gateway.iokey.ifm":
        return (
          <image
            src="https://media.ifm.com/CIP/mediadelivery/rendition/6a8d9e0f4e86634aa291817975465a58/-B900-FJPG/SD5100"
            alt="io_link Sensor"
          />
        );
      case parentType === "ts.device.gateway.lorawan.multitech":
        if (device.fields && "Temperature" in device.fields) {
          return (
            <image
              src="https://www.multitech.com/documents/media/images/products/sensors/air-temp-humidity/Industrial_RBS306-ATH-EXT.png"
              alt="Lorawan Temperature Sensor"
            />
          );
        } else {
          return (
            <image
              src="https://www.multitech.com/documents/media/images/products/sensors/movement/Indoor_RBS301-ABM.png"
              alt="Lorawan Door Sensor"
            />
          );
        }
      default:
        return (
          <image
            src="https://media.ifm.com/CIP/mediadelivery/rendition/6a8d9e0f4e86634aa291817975465a58/-B900-FJPG/SD5100"
            alt="Sensor"
          />
        );
    }
  }
}

export function getParentDevice(state) {
  let sessionDeviceList = JSON.parse(sessionStorage.getItem("deviceList"));
  let parentDevice = {};

  sessionDeviceList.map((device) => {
    if (device["uid"] === state["parentdeviceid"]) {
      parentDevice = device;
      console.log(parentDevice);
      return parentDevice;
    } else {
      return "Device has no parent device";
    }
  });
  return parentDevice;
}

export function getFieldNameFromState(state) {
  let fieldNames = Object.keys(state.fields);
  let fieldNameArray = [];
  if (fieldNames.length > 0 && fieldNames) {
    fieldNames.map((field) => {
      fieldNameArray.push(field);
      console.log(fieldNameArray);
    });
  } else {
    console.log(`Cannot get field name from state: ${state}`);
  }
  return fieldNameArray;
}

export function setGateAndSensorArray(gatewayArray, sensorArray) {
  return gatewayArray && sensorArray;
}

export function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        Dashboard
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <MenuItem onClick={handleClose}>Logout</MenuItem>
      </Menu>
    </div>
  );
}

/**
 * To generate text to which should be displayed for the table filter
 * @param {stringify} valueProp
 * @param {string} value
 * @param {Function} callbackFun
 * @returns {string} displayText
 */

const getDisplayText = (valueProp, value) => {
  if (valueProp === "state") {
    return value === "ready" ? "Online" : "Offline";
  }
  return value;
};

/**
 * To create an array of items for the table filter
 * tableRow object and valueProp string are mandatory
 * @param {Object} item
 * @param {string} valueProp
 * @param {function} callbackFun
 * @returns {Array} filterList
 */
export const createTableFilterList = (
  tableRow = [],
  valueProp,
  filterType = null,
  callbackFun
) => {
  const filterList = [];
  if (tableRow.length <= 0) return filterList;
  let uniqueObj = {};

  tableRow.forEach((item, index) => {
    let value =
      item[valueProp] && item[valueProp] && item[valueProp].trim() !== ""
        ? item[valueProp]
        : "";
    if (value && filterType === "TIME_FILTER") {
      value = GmtToLocal(value);
      value = value.split(" ").slice(0, 3).join(" ").trim();
    }
    if (valueProp === "severity") {
      value = `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
    }
    if (callbackFun) {
      value = callbackFun(value, tableRow);
    }

    if (value && !uniqueObj.hasOwnProperty(value)) {
      uniqueObj = { ...uniqueObj, [value]: index };
      filterList.push({ text: getDisplayText(valueProp, value), value: value });
    }
  });
  return filterList;
};

/**
 * To create Static filiter list
 * @param {Object} obj
 * @returns array of text and value field obj
 */
export const createTableFilterStaticList = (obj) => {
  if (obj.page === "Alerts" && obj.key === "Status") {
    return [
      { text: "Read", value: "Read" },
      { text: "Closed", value: "Closed" },
      { text: "New", value: "New" },
    ];
  }
  if (obj.page === "Rules") {
    return obj.key === "Status"
      ? [
          { text: "Disabled", value: "disabled" },
          { text: "Enabled", value: "enabled" },
        ]
      : obj.key === "RuleType"
      ? [
          { text: "System", value: true },
          { text: "Custom", value: false },
        ]
      : [];
  }
};
/**
 * To sort alert table based on thier status
 * @param {Object} a
 * @param {Object} b
 * @returns {number} 1 or -1 for sorting
 */
export const createSorterForAlertStatus = (a, b) => {
  const status = { Closed: 3, Read: 2, New: 1 };
  return status[a.iscleared ? "Closed" : a.isacknowledged ? "Read" : "New"] <
    status[b.iscleared ? "Closed" : b.isacknowledged ? "Read" : "New"]
    ? -1
    : 1;
};

//get random unique ids
export function getRandomId(prefix, length = 8) {
  return `${prefix}_${Math.random().toString(36).substr(2, length)}`;
}

/**
 * To get all the device list data - this will be called onload and on reload of the device table
 */
//  This function is currently not in use, when using this in future read below comments
//  Kindly note "fetchv1DeviceDetailsEndPoint" end point has been switched from V2 to V1,
//  when using this function kindly take care of making payload related changes
export const refreshAllDeviceList = async (filters) => {
  try {
    const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify(filters),
    });
    const deviceList = await response.json();
    if (deviceList.error) {
      if (
        deviceList.error_description ===
        "Invalid token type in Authorization header."
      ) {
        alert("Invalid Token, Please login first");
      } else if (deviceList.error === "unauthorized_client") {
        alert(
          "This user is not authorized to fetch device list, please log in as device user"
        );
      } else if (deviceList.error === "bad_request") {
        alert("Bad request");
      }
      sessionStorage.setItem("deviceList", JSON.stringify(deviceList));
      return deviceList;
    }

    if (deviceList.length === 0) {
      return deviceList;
    }
    sessionStorage.setItem("deviceList", JSON.stringify(deviceList));
    return deviceList;
  } catch (error) {
    console.log(error);
  }
};
export const refreshmapAllDeviceList = async (filters) => {
  try {
    const response = await fetch(fetchV1DeviceEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify(filters),
    });
    const deviceList = await response.json();
    if (deviceList.error) {
      if (
        deviceList.error_description ===
        "Invalid token type in Authorization header."
      ) {
        alert("Invalid Token, Please login first");
      } else if (deviceList.error === "unauthorized_client") {
        alert(
          "This user is not authorized to fetch device list, please log in as device user"
        );
      } else if (deviceList.error === "bad_request") {
        alert("Bad request");
      }
      return deviceList;
    }

    if (deviceList.length === 0) {
      return deviceList;
    }
    return deviceList;
  } catch (error) {
    console.log(error);
  }
};
export const updateSelectedAlert = async (payload) => {
  const response = await fetch(updateSmartAlertEndPoint(), {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: payload,
  });

  if (!response.ok) throw new Error("Response Error");
  const updateAlertsRsp = await response.json();

  return updateAlertsRsp;
};
export const createUserList = async (val, sentemail) => {
  try {
    const response = await fetch(createUserEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        email: val?.email,
        firstname: val?.firstName,
        lastname: val?.lastName,
        mdn: val?.mobileNumber,
        noEmailVerification: true,
        password: "",
        sentemail: sentemail,
        customdata: { orgId: val?.organization, roleId: val?.role },
        groupids: [val?.role],
      }),
    });
    const userList = await response.json();
    if (userList.length === 0) {
      return userList;
    }
    return userList;
  } catch (error) {
    console.log(error);
  }
};

export function isValidURL(url) {
  try {
    // Accept both absolute and relative URLs
    const parsedUrl = new URL(url, window.location.origin);

    // Block javascript: and other dangerous protocols
    const forbiddenProtocols = ["javascript:", "data:", "vbscript:"];
    if (forbiddenProtocols.includes(parsedUrl.protocol)) {
      return false;
    }

    // Block URLs containing suspicious characters or patterns
    const forbiddenPatterns = [
      /<script[\s\S]*?>/i,
      /on\w+=/i, // inline event handlers
      /%3Cscript%3E/i, // encoded <script>
      /javascript:/i,
      /data:/i,
      /vbscript:/i,
      /base64,/i,
      /<img[\s\S]*?src=/i,
      /<iframe[\s\S]*?>/i,
      /<object[\s\S]*?>/i,
      /<embed[\s\S]*?>/i,
      /<svg[\s\S]*?>/i,
      /<link[\s\S]*?>/i,
      /<meta[\s\S]*?>/i,
    ];

    for (const pattern of forbiddenPatterns) {
      if (pattern.test(url)) {
        return false;
      }
    }

    // Optionally, restrict allowed protocols (http, https)
    if (!["http:","https:"].includes(parsedUrl.protocol)) {
      return false;
    }

    // Optionally, restrict allowed hostnames
    // if (!["yourdomain.com", "localhost"].includes(parsedUrl.hostname)) {
    //   return false;
    // }

    return true;
  } catch (err){
    console.log('URL validation error: ', err);
    return false;
  }
}

export function sanitizeSVG(svgString) {
  return DOMPurify.sanitize(svgString, { USE_PROFILES: { svg: true } });
}

export const updateUserList = async (val) => {
  try {
    let response;
    if (val?.role !== val?.oldroleid) {
      response = await fetch(updateUserEndPoint(), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify({
          billingaccountid: sessionStorage.getItem("accountId"),
          id: val?.id,
          user: {
            firstname: val?.firstName,
            lastname: val?.lastName,
            mdn: val?.mobileNumber,
            customdata: { orgId: val?.organization, roleId: val?.role },
          },
          removeGroupIds: [val?.oldroleid],
          addGroupIds: [val?.role],
        }),
      });
    } else {
      response = await fetch(updateUserEndPoint(), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify({
          billingaccountid: sessionStorage.getItem("accountId"),
          id: val?.id,
          user: {
            firstname: val?.firstName,
            lastname: val?.lastName,
            mdn: val?.mobileNumber,
            customdata: { orgId: val?.organization, roleId: val?.role },
          },
        }),
      });
    }
    const userList = await response.json();
    if (userList.length === 0) {
      return userList;
    }
    return userList;
  } catch (error) {
    console.log(error);
  }
};

export const createRolesList = async (val) => {
  try {
    const response = await fetch(createRolesEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        group: {
          name: val?.roleName,
          description: val?.description,
          permissions: val?.permissions,
        },
      }),
    });
    const RolesList = await response.json();
    if (RolesList.length === 0) {
      return RolesList;
    }
    return RolesList;
  } catch (error) {
    console.log(error);
  }
};
export const validateAlertsGroupAPI = async (name) => {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    name: name,
  };
  try {
    const response = await fetch(validateAlertsGroupName(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      },
      method: "POST",
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return {
      status: response.status,
      data: data,
    };
  } catch (error) {
    return {
      status: 500,
      data: { error: "An error occurred while processing the request" },
    };
  }
};
export const validateRolesNameAPI = async (name) => {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    name: name,
  };
  try {
    const response = await fetch(validateRolesName(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      },
      method: "POST",
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return {
      status: response.status,
      data: data,
    };
  } catch (error) {
    return {
      status: 500,
      data: { error: "An error occurred while processing the request" },
    };
  }
};
export const updateRoleList = async (val) => {
  try {
    const response = await fetch(updateRoleEndPoint(), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        roleId: val?.id,
        group: {
          name: val?.roleName,
          description: val?.description,
        },
        permissions: val?.permissions,
      }),
    });
    const RolesList = await response.json();
    if (RolesList.length === 0) {
      return RolesList;
    }
    return RolesList;
  } catch (error) {
    console.log(error);
  }
};

export const createOrgList = async (val) => {
  try {
    const response = await fetch(createOrganizationEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tags: [
          {
            kind: "ts.tag.org",
            name: val?.orgName,
          },
        ],
      }),
    });
    const OrgList = await response.json();
    if (OrgList.length === 0) {
      return OrgList;
    }
    return OrgList;
  } catch (error) {
    console.log(error);
  }
};
export const updateOrgList = async (val) => {
  try {
    const response = await fetch(updateOrganizationEndPoint(), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        resourceidentifier: {
          id: val?.id
        },
        tag: {
          kind: "ts.tag.org",
          name: val?.orgName,
        },
      }),
    });
    const OrgList = await response.json();
    if (OrgList.length === 0) {
      return OrgList;
    }
    return OrgList;
  } catch (error) {
    console.log(error);
  }
};
export const createLocation = async (val) => {
  try {
    const regex = /(-?\d+\.\d+),\s*(-?\d+\.\d+)/;
    const match = val?.gpslocation?.match(regex);
    let lat;
    let long;
    if (match) {
      lat = parseFloat(match[1]);
      long = parseFloat(match[2]);
    } else {
      lat = parseFloat(val?.gpslocation);
    }
    const response = await fetch(createLocationEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: val?.createtype==='inventory_location' ? 
      JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tags: [
          {
            kind: "ts.tag.site",
            ...val
          }]
        }
        )
      :JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tags: [
          {
            kind: "ts.tag.site",
            name: val?.locationName,
            loc_type: val?.locationtype,
            org_name: val?.organization,
            address: val?.address,
            lat_value: lat,
            long_value: long,
            radius: val?.geofench,
            orgId: val?.orgId,
            adjustGeofenceMap: val?.adjustGeofenceMap,
          },
        ],
      }),
    });
    const LocationList = await response.json();
    if (LocationList.length === 0) {
      return LocationList;
    }
    return LocationList;
  } catch (error) {
    console.log(error);
  }
};
export const updateLocation = async (val) => {
  try {
    const regex = /(-?\d+\.\d+),\s*(-?\d+\.\d+)/;
    const match = val?.gpslocation?.match(regex);
    let lat;
    let long;
    if (match) {
      lat = parseFloat(match[1]);
      long = parseFloat(match[2]);
    } else {
      lat = parseFloat(val?.gpslocation);
    }
    const response = await fetch(updateLocationEndPoint(), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        resourceidentifier: { id: val?.id },
        tag: val?.createtype==='inventory_location' ? 
        {
          kind: "ts.tag.site",
          ...val
        }
        :{
          kind: "ts.tag.site",
          name: val?.locationName,
          loc_type: val?.locationtype,
          org_name: val?.organization,
          orgId: val?.orgId,
          address: val?.address,
          lat_value: lat,
          long_value: long,
          adjustGeofenceMap: val?.adjustGeofenceMap,
          radius: val?.geofench,
        },
      }),
    });
    const LocationList = await response.json();
    if (LocationList.length === 0) {
      return LocationList;
    }
    return LocationList;
  } catch (error) {
    console.log(error);
  }
};

export const fetchAlarms = async (request, setAlarms) => {
  try {
    //const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
    const response = await fetch(fetchAlarmsListEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify(request),
    });
    const data = await response.json();
    if (data) {
      setAlarms(data.data);
    }
  } catch (error) {
    return error;
  }
};

/**
 * To set the Detive nick name based on the kind property of the device / parent devcie
 */
export const setDeviceTypeNickName = (device, parent) => {
  let nickname;
  if (device && device != null) {
    switch (device.kind) {
      case "ts.device.tgAssetTracker": {
        nickname = "BLE Gateway";
        break;
      }
      case "ts.device.dmp": {
        nickname = "Camera Gateway";
        break;
      }
      case "ts.device.gateway": {
        nickname = "TS Edge Gateway";
        break;
      }
      case "ts.device.ble": {
        nickname = "BLE Sensor";
        break;
      }
      case "ts.device.gateway.lorawan.multitech": {
        nickname = "Multitech Gateway";
        break;
      }
      case "ts.device.gateway.iokey.ifm": {
        nickname = "IOKey Gateway";
        break;
      }
      case "ts.device": {
        if (device.parentdeviceid) {
          let parentDevice =
            parent.uid === device.parentdeviceid ? parent : device;

          //let parentDevice = deviceList.filter(device => device.uid=== deviceList[i].parentdeviceid)[0];
          if (parentDevice) {
            //console.log(parentDevice, parentDevice.kind);
            if (parentDevice.kind.includes("lorawan")) {
              nickname = "LoRa Sensor";
            } else if (parentDevice.kind.includes("iokey")) {
              nickname = "IOKey Sensor";
            } else if (parentDevice.kind.includes("ts.device.tgAssetTracker")) {
              nickname = "BLE Sensor";
            } else {
              console.log("parentDevice ", parentDevice.kind);
            }
          } else {
            nickname = device.kind;
            console.log(
              "No gateway info found for device: ",
              device.name,
              "parentdeviceid: ",
              device.parentdeviceid
            );
          }
        }
        break;
      }
      default: {
        nickname = device.kind;
      }
    }
  }
  return { ...device, nickname };
};

export const getGateWayOrSensorHealthDetailData = (data = null) => {
  if (!data) return;
  console.log(data?.fields?.healthscores);
  const getBatteryPercent = (data) => {
    const batteryScore =
      typeof data?.fields?.healthscores?.batteryScore === "number"
        ? data?.fields?.healthscores?.batteryScore
        : "N/A";
    return batteryScore === "N/A"
      ? batteryScore
      : getHealthScorePercentage(Number(batteryScore));
  };
  const getFormatedDays = (data) => {
    if (!data?.fields?.BatteryRemainingDays) return { val: "N/A", color: "" };
    const daysStr = data?.fields?.BatteryRemainingDays;
    return daysStr.slice(daysStr.length - 1) === "D"
      ? {
          val: `${daysStr.slice(0, daysStr.length - 1)} Days`,
          color: "var(--sasp-secondary-orange)",
        }
      : { val: daysStr, color: "var(--sasp-secondary-orange)" };
  };

  const getSignalStrengthInPercentage = (data) => {
    const signalStrengthScore =
      typeof data?.fields?.healthscores?.signalStrengthScore === "number"
        ? data?.fields?.healthscores?.signalStrengthScore
        : "N/A";
    return signalStrengthScore === "N/A"
      ? signalStrengthScore
      : getHealthScorePercentage(Number(signalStrengthScore));
  };

  const getmissingDataIn30DaysPercetage = (data) => {
    const missingDataRecordsIn30Days =
      typeof data?.fields?.healthscores?.missingDataRecordsIn30Days === "number"
        ? data?.fields?.healthscores?.missingDataRecordsIn30Days
        : "N/A";
    return missingDataRecordsIn30Days === "N/A"
      ? missingDataRecordsIn30Days
      : getHealthScorePercentage(Number(missingDataRecordsIn30Days));
  };

  const signalStrengthPercentage = getSignalStrengthInPercentage(data);
  const missingDataRecordsIn30Days = getmissingDataIn30DaysPercetage(data);
  const deviceStatus =
    data?.fields?.healthscores?.deviceStatus === 1 ? "Online" : "Offline";
  const batteryPercentage = getBatteryPercent(data);
  const remainingBatteryDays = getFormatedDays(data);
  const arrayData = [
    {
      name: "Battery Health",
      value:
        batteryPercentage === "N/A"
          ? batteryPercentage
          : `${batteryPercentage}%`,
      textColor: getHealthScoreColor(batteryPercentage, true),
    },
    {
      name: "Remaining days of battery life",
      value: remainingBatteryDays?.val,
      textColor: remainingBatteryDays?.color,
    },
    {
      name: "Signal Health",
      value:
        signalStrengthPercentage === "N/A"
          ? signalStrengthPercentage
          : `${signalStrengthPercentage}%`,
      textColor: getHealthScoreColor(signalStrengthPercentage, true),
    },
    {
      name: "Device status",
      value: deviceStatus,
      textColor:
        deviceStatus === "Online"
          ? "var(--sasp-primary-green)"
          : "var(--sasp-secondary-orange)",
    },
    {
      name: "% of missing data packages in 30 days",
      value:
        missingDataRecordsIn30Days === "N/A"
          ? "N/A"
          : `${missingDataRecordsIn30Days}%`,
      textColor: getHealthScoreColor(missingDataRecordsIn30Days, true),
    },
    { name: "Network Current Status", value: "N/A" },
    { name: "Network Availability History (30 days)", value: "N/A" },
    { name: "Device Offline in past 30 days", value: "N/A" },
  ];
  return arrayData;
};

export const getValidHealthScore = (data) => {
  const healthScoreVal = !isNaN(data?.fields?.healthscores?.overall)
    ? data?.fields?.healthscores?.overall
    : "N/A";
  return healthScoreVal;
};

export const getHealthScorePercentage = (value) => {
  return parseFloat((value * 100).toFixed(2));
};

export function getIsLora(sensorData) {
  let lora = false;

  if (sensorData?.data?.nickname === "LoRa Sensor") {
    lora = true;
  }

  return lora;
}
export const getHealthScoreSummary = (healthScoreData) => {
  return healthScoreData.reduce(
    (obj, item) => (
      (obj[item.metrictype] = isNaN(item.metricvalue)
        ? item.metricvalue
        : `${getHealthScorePercentage(Number(item.metricvalue))}%`),
      obj
    ),
    {}
  );
};

export const getHealthScoreColor = (
  text,
  isConvertedToPercentage,
  isNotClass
) => {
  console.log(text);
  const healscorePercentage = !isConvertedToPercentage
    ? getHealthScorePercentage(Number(text))
    : text;
  switch (true) {
    case healscorePercentage >= 90:
      return isNotClass
        ? "var(--sasp-primary-green)"
        : `sasp_health-score-good-text-color`;
    case healscorePercentage <= 70:
      return isNotClass
        ? "var(--sasp-secondary-orange)"
        : `sasp_health-score-orange-text-color`;
    case healscorePercentage < 90:
      return isNotClass
        ? "var(--sasp-primary-yellow)"
        : `sasp_health-score-yellow-text-color`;
    default:
      return "sasp_vz-nhg-eds-font";
  }
};

export const getConditionSymbol = (ruleCondition) => {
  const availableCondition = {
    "Greater Than": ">",
    "Less Than": "<",
    "Greater Than OR Equal To": ">=",
    "Less Than OR Equal To": "<=",
    "Equal To": "=",
    "NOT Equal To": "!=",
  };
  return availableCondition[ruleCondition] || "";
};
export const fetchOrganization = async () => {
  try {
    const response = await fetch(fetchOrganizationEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: { $sort: [{ field: "createdon", order: "desc" }] },
      }),
    });

    if (!response.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchLocation = async () => {
  try {
    const response = await fetch(fetchLocationEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: { $sort: [{ field: "createdon", order: "desc" }] },
      }),
    });

    if (!response.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchAllAssetsCount = async () => {
  try {
    const response = await fetch(fetchallassetCountEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: {
          $sort: [
            { field: "createdon", order: "desc", assettype: "allassets" },
          ],
        },
      }),
    });

    if (!response.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchAssetsCount = async () => {
  try {
    const response = await fetch(fetchassetCountEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: { $sort: [{ field: "createdon", order: "desc" }] },
      }),
    });

    if (!response.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchLostCount = async () => {
  try {
    const response = await fetch(fetchLostCountEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: { $sort: [{ field: "createdon", order: "desc" }] },
      }),
    });

    if (!response.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchProdCount = async () => {
  try {
    const response = await fetch(fetchProdCountEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: { $sort: [{ field: "createdon", order: "desc" }] },
      }),
    });

    if (!response.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchLatLong = async (address) => {
  try {
    const response = await fetch(fetchLatLongEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        locations: [
          {
            requestid: generateRandomNumber(),
            addressstring: address,
          },
        ],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

const generateRandomNumber = () => {
  const min = 100000000000;
  const max = 999999999999;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
export const fetchRoles = async () => {
  try {
    let activeSession = sessionStorage.getItem("activeSession");
    if (activeSession) {
      activeSession = JSON.parse(activeSession);
    }
    const response = await fetch(fetchRolesEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        currentrole: "ORG_ADMIN"
        // currentrole: activeSession?.role?.name,
        //filter: { $sort: [{ field: "name", order: "asc" }] },
      }),
    });
    if (!response?.ok) throw new Error("Something went wrong");

    return await response.json();
  } catch (error) {
    return error;
  }
};
export function deviceModeListGroupBy(collection, property) {
  var i = 0,
    val,
    index,
    values = [],
    result = [];
  for (; i < collection.length; i++) {
    val = collection[i][property];
    index = values.indexOf(val);
    if (index > -1) result[index].push(collection[i]);
    else {
      values.push(val);
      result.push([collection[i]]);
    }
  }
  return result;
}
export const fetchMyprofile = async () => {
  try {
    const response = await fetch(fetchMyprofileEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: { $sort: [{ field: "createdon", order: "desc" }] },
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const updateDeviceManager = async (id, payLoad) => {
  try {
    const response = await fetch(updateDeviceEndPoint() + `/updatedevices`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "PATCH",
      body: payLoad,
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const createDeviceManager = async (payLoad) => {
  try {
    const response = await fetch(updateDeviceEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: payLoad,
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const updateMyprofile = async (val) => {
  try {
    const response = await fetch(fetchMyprofileEndPoint(), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        billingaccountid: sessionStorage.getItem("accountId"),
        firstname: val?.firstName,
        lastname: val?.lastName,
        mdn: val?.mobileNumber,
      }),
    });
    const myprofile = await response.json();
    if (!myprofile || (Array.isArray(myprofile) && myprofile.length === 0)) {
      return null;
    }
    return myprofile;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export function getField(field) {
  return field.indexOf(".") == -1 ? field : field.split(".")[1];
}

export const fetchassetmap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'location' AND $/fields/location/type eq 'gps' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchLocationAlerts = async (
  deviceId,
  startTime,
  endTime,
  shipmentId
) => {
  try {
    const response = await fetch(fetchLocationAlertsEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        deviceId,
        startTime,
        endTime,
        shipmentId,
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchLocationAlertsAsset = async (
  deviceId,
  startTime,
  endTime,
  assetId
) => {
  try {
    const response = await fetch(fetchLocationAlertsEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        deviceId,
        startTime,
        endTime,
        assetId,
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchassetmapNoType = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND ($/fields containskey 'location' OR $/fields containskey 'temperature' OR $/fields containskey 'battery') AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "lastupdated", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchassetRssimap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'rssi' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchassetsignalStrengthmap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'signalStrength' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchTemperaturemap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'temperature' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchHumiditymap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'humidity' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchPressuremap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'pressure' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchGatewayTelemetrymap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND ($/fields containskey 'location' OR $/fields containskey 'battery' OR $/fields containskey 'signalStrength') AND createdon between('2024-10-11T09:52','2024-10-18T09:52'))`,
        $sort: [
          {
            field: "createdon",
            order: "asc",
          },
        ],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export const fetchassetPositionmap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields/location containskey 'radius')`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchassetAccelerationmap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'acceleration' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchassetMotionmap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'motion' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "desc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchLocationHistorymap = async (val) => {
  try {
    const response = await fetch(fetchLocationHistorymapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        deviceid: val?.uid,
        startDate: val?.endDateTime,
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchassetBatterynmap = async (val) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        // "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${val?.uid}' AND $/fields containskey 'battery' AND createdon between('${val?.startDate}','${val?.endDateTime}'))`,
        $sort: [{ field: "createdon", order: "asc" }],
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const fetchindividualVal = async (id) => {
  try {
    const response = await fetch(fetchDeviceValEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        $filter: `(id eq '${id}')`,
      }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};
export const setuppassword = async (val) => {
  try {
    const response = await fetch(setupUserEndPoint(), {
      headers: {
        Authorization: "Bearer " + val.bearerToken,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ password: val.password }),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const capitalize = (s) => {
  if (typeof s !== "string") return s;
  if (s == undefined || s === null) return s;
  if (s.length < 2) return s;
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

const isTwoMinsRange = (t1, t2, t3) => {
  const times = [new Date(t1), new Date(t2), new Date(t3)]
    .map((d) => d.getTime())
    .sort((a, b) => a - b);
  const max = times[2];
  const min = times[0];
  const diffMins = (max - min) / (1000 * 60);
  return diffMins <= 2;
};

//this function merges different objects based on same timestamp which are continuously serialize
export const mergeBasedOnCommonProperty = (data) => {
  const mergeArr = {};
  data.forEach((elem, i) => {
    const nextElem = data[i + 1];
    const next2Elem = data[i + 2];
    if (
      isTwoMinsRange(
        elem?.lastupdated,
        nextElem?.lastupdated,
        next2Elem?.lastupdated
      )
    ) {
      let mergeElem = {
        ...elem?.fields,
        ...nextElem?.fields,
        ...next2Elem?.fields,
        lastupdated: elem?.lastupdated,
      };
      mergeElem = {
        ...mergeElem,
        location: [
          mergeElem?.location?.longitude,
          mergeElem?.location?.latitude,
          mergeElem?.lastupdated,
        ],
        accuracy: mergeElem?.location?.accuracy,
      };
      if (mergeElem?.location && mergeElem?.temperature && mergeElem?.battery) {
        mergeArr[elem?.lastupdated] = mergeElem;
      }
    }
  });
  return mergeArr;
};

export const createMetricsFromResponse = (arg) => {
  let last_lattitude = arg.originCoord[1];
  let last_longitude = arg.originCoord[0];
  let last_battery = arg?.metrics?.battery;
  let last_temperature = arg?.metrics?.temperature;
  let last_accuracy = 0;
  let last_type = arg?.type;
  let last_alertSeverity = arg?.alertType;
  return arg.data.map((ele) => {
    let {
      battery = "N/A",
      temperature = "N/A",
      longitude = "N/A",
      latitude = "N/A",
      createdon: timestamp = "N/A",
      alertSeverity = "N/A",
      accuracy = "N/A",
      type = "Unknown",
    } = ele;

    if (battery !== "N/A") {
      last_battery = battery;
    } else {
      battery = last_battery;
    }

    if (accuracy !== "N/A") {
      last_accuracy = accuracy;
    } else {
      accuracy = last_accuracy;
    }

    if (temperature !== "N/A") {
      temperature = temperature;
      last_temperature = temperature;
    } else {
      temperature = last_temperature;
    }

    if (longitude !== "N/A" && latitude !== "N/A") {
      last_longitude = longitude;
      last_lattitude = latitude;
    } else {
      latitude = last_lattitude;
      longitude = last_longitude;
    }

    if (type !== "Unknown") {
      last_type = type;
    } else {
      type = last_type;
    }

    if (alertSeverity !== "N/A") {
      last_alertSeverity = alertSeverity;
    } else {
      alertSeverity = last_alertSeverity;
    }

    battery = isNaN(battery) ? "N/A" : Math.round((battery + Number.EPSILON) * 10) / 10;
    temperature = isNaN(temperature) ? "N/A" : Math.round((temperature + Number.EPSILON) * 10) / 10;

    return {
      battery,
      temperature,
      coords: [longitude, latitude],
      timestamp,
      alertSeverity,
      accuracy,
      type
    };
  });
};

/**
 * Groups an array of sensor data objects by 'createdon' timestamp and
 * merges their properties, using the previous available value for any
 * key that is currently missing (forward-filling).
 * * @param {Array<Object>} dataArray - The array of sensor data objects.
 * @returns {Array<Object>} The transformed array with merged and forward-filled records.
 */
export const createMetricsFromResponseForAsset = (dataArray) => {
    // 1. lastKnownValues stores the last non-null value for every key encountered.
    const lastKnownValues = {};
    const groupedData = {};

    for (const record of dataArray) {
        const createdOn = record.createdon;

        if (!createdOn) {
            continue; 
        }

        // --- Step A: Update lastKnownValues and merge current record ---
        
        // Ensure the group entry exists and is initialized with the current record's timestamp.
        if (!groupedData[createdOn]) {
            groupedData[createdOn] = { createdon: createdOn };
        }

        // Update the group entry with values from the current record and simultaneously
        // update the lastKnownValues for each key.
        for (const key in record) {
            if (key !== 'createdon' && record[key] !== undefined && record[key] !== null) {
                // 1a. Update the current group entry with the new data
                groupedData[createdOn][key] = record[key];
                
                // 1b. Update the last known value
                lastKnownValues[key] = record[key];
            }
        }
    }

    // --- Step B: Forward-fill missing values in the final array ---
    
    // Convert the dictionary values to an array to process them in order of timestamp
    let finalArray = Object.values(groupedData);

    // Sort the array by createdon to ensure filling occurs chronologically (optional, but robust)
    finalArray.sort((a, b) => new Date(a.createdon) - new Date(b.createdon));
    
    // This second pass uses the 'lastKnownValues' object from the first pass to fill initial gaps,
    // and then uses the values from the *previous merged object* to fill subsequent gaps.
    let previousMergedRecord = { ...lastKnownValues }; // Start with the last values from the whole set

    for (const mergedRecord of finalArray) {
        for (const key in previousMergedRecord) {
            // If the key is missing in the current merged record, fill it with the previous value.
            if (key !== 'createdon' && mergedRecord[key] === undefined) {
                mergedRecord[key] = previousMergedRecord[key];
            }
        }
        // Update the previousMergedRecord for the next iteration
        previousMergedRecord = { ...previousMergedRecord, ...mergedRecord };
    }

    return finalArray;
}

export function isValidSafeUUIDv4(param) {
  const uuidV4Regex = /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[89ab][0-9a-z]{4}-[0-9a-z]{12}$/i;
  if (
    typeof param !== "string" ||
    !uuidV4Regex.test(param) ||
    param.includes(".com") ||
    param.includes("http") ||
    param.includes("https") ||
    param.match(/^(javascript|data|vbscript):/i)
  ) {
    return false;
  }
  return true;
}

export function addAccuracyCircle(coords, accuracyRadius, map, bounds, haloRegionType='') {
  let center = [-117.53536, 34.044672];

  if (coords[0] && coords[1]) {
    center = [coords[0], coords[1]];
  }
  const radius = accuracyRadius;
  const options = {
    steps: 150,
    units: "meters",
  };

  if (map?.getLayer(`haloRegionLayer${haloRegionType}`)) {
    map?.removeLayer(`haloRegionLayer${haloRegionType}`);
  }
  if (map?.getLayer(`haloRegion-outline${haloRegionType}`)) {
    map?.removeLayer(`haloRegion-outline${haloRegionType}`);
  }
  if (map?.getSource(`haloRegion${haloRegionType}`)) {
    map?.removeSource(`haloRegion${haloRegionType}`);
  }

  let circle = turf.circle(center, radius, options);
  map?.addSource(`haloRegion${haloRegionType}`, {
    type: "geojson",
    data: circle,
  });

  map?.addLayer({
    id: `haloRegionLayer${haloRegionType}`,
    type: "fill",
    source: `haloRegion${haloRegionType}`,
    paint: {
      "fill-color": "#000000",
      "fill-opacity": 0.2,
    },
  });

  // map?.flyTo({
  //   center:center,
  //   zoom: 20,
  //   speed:2.5
  // });

  // const timer = setTimeout(() => map.fitBounds(bounds, { padding: 90 }), 2000);
  // return () => clearTimeout(timer);
}

export const returnPopups = (obj) => {
  const {
    locationName = null,
    state = null,
    status = null,
    Address = null,
    timestamp = null,
    loc_type = null,
    statusClass = "",
    noNeed = true,
    statusInfo = null,
    statusid = null,
    statusCls = null,
  } = obj;
  return `<div>
              ${
                locationName && noNeed
                  ? `<div class="loc_type_cls light-grey-text-color">
                         ${loc_type || "N/A"} 
                      </div>`
                  : state && status
                  ? `<div class="ship_state_status_cls">
                        <div class="ship_state_cls state-map-label">
                          ${capitalize(state) || "Unknown"}
                        </div>
                        <div id=${
                          statusid || "statusClickView"
                        } data-text='${capitalize(
                      status
                    )}' data-info="${statusInfo}" class="ship_status_cls warning-map-label map-status-${statusClass
                      ?.toLowerCase()
                      .replaceAll(" ", "-")} ${statusCls}">
                          ${capitalize(status) || "Unknown"}
                        </div>
                      </div>`
                  : `<div id="statusClickView" data-info="${statusInfo}"  data-text='${capitalize(
                      status
                    )}' class="ship_status_cls warning-map-label map-status-${statusClass
                      ?.toLowerCase()
                      .replaceAll(" ", "-")}">
                          ${capitalize(status) || "Unknown"}
                      </div>`
              }
              ${
                locationName
                  ? `<div class="loc_type_name_cls">
                        <strong style="word-wrap: break-word">
                           <p style='font-family:VerizonNHGDSBold; ${
                             !noNeed ? "font-size:16px !important" : ""
                           }'> ${locationName || "N/A"} </p>
                        </strong>
                      </div>`
                  : state || status
                  ? `<div class="ship_state_status_addr_cls">
                        ${Address || "N/A"}
                      </div>`
                  : ""
              }
              ${
                locationName
                  ? `<div class="loc_type_addr_cls" style='${
                      !noNeed ? "font-size:12px !important" : ""
                    }'>
                          ${Address || "N/A"}
                      </div>`
                  : state || status
                  ? `<div class="ship_state_status_tmstmp_cls ship_state_status_addr_cls">
                        
                          ${
                            timestamp
                              ? dayjs(timestamp).format("DD MMM YYYY HH:mm:ss")
                              : "Unknown"
                          }
                        
                      </div>`
                  : ""
              }  
            </div>`;
};
export function popUpAndIndicator(
  coords,
  popupstr,
  indicatorHtml,
  map,
  anchor
) {
  const popup = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: true,
    offset: 25,
    // anchor: anchor || "right",
  })
    ?.setLngLat(coords)
    .setHTML(`<div class="custom-map-popup">${popupstr}</div>`)
    .addClassName("customPopupCurrMapClass");

  function showPopup() {
    popup.addTo(map);
  }
  function removePopup() {
    popup.remove();
  }
  const indicator = new mapboxgl.Marker({
    element: document.createElement("div"),
  });
  indicator.getElement().innerHTML = indicatorHtml;

  let isHover = false;
  let isClick = false;

  indicator.getElement().addEventListener("mouseenter", (e) => {
    isHover = true;
    // isClick=false;
    e.target.style.cursor = "pointer";
    showPopup();
  });

  indicator.getElement().addEventListener("mouseleave", (e) => {
    e.target.style.cursor = "";
    if (!isClick || isHover) {
      removePopup();
    }
  });

  indicator.getElement().addEventListener("click", (e) => {
    isHover = false;
    isClick = true;
    e.target.style.cursor = "pointer";
    showPopup();
  });
  indicator?.setLngLat(coords).addTo(map);
  return { popup, indicator };
}

export const fetchassetmapauto = async (deviceid) => {
  try {
    const response = await fetch(fetchassetmapEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      },
      method: "POST",
      body: JSON.stringify({
        $filter: `(deviceid eq '${deviceid}' AND $/fields containskey 'rssi')`,
        $sort: [{ field: "lastupdated", order: "desc" }],
        $limitnumber: 1,
        $pagenumber: 0,
      }),
    });
    const data = await response.json();
    //  return data?.data?.[0]?.fields?.rssi || [];
    return data?.data?.[0] || [];
  } catch (error) {
    return error;
  }
};

export function removeAccountPrefixFromLabels(labels) {
  if (!Array.isArray(labels)) return [];
  let accountName = sessionStorage.getItem("accountId");
  return labels.map(label => {
    if (label.startsWith(`AG_${accountName}_`)) {
      return label.slice(`AG_${accountName}_`.length);
    } else if (label.startsWith(`${accountName}_`)) {
      return label.slice(`${accountName}_`.length);
    }
    return label;
  });
}
export function removeAccountPrefix(labels) {
  if (!labels) return "";
  const accountNumber = sessionStorage.getItem("accountId");
  if (!accountNumber) return labels;
  const prefix = `AG_${accountNumber}_`;
  return labels
    .split(",")
    .map(item => (item.startsWith(prefix) ? item.replace(prefix, "") : item))
    .join(",");
}
 export function getMinimum (title, fallback){
      if (title?.startsWith("Anymotion")) return 0.1;
      if (title?.startsWith("Shock")) return 0;
      if (title?.startsWith("Tilt")) return 3;
      return fallback;
      };

   const getValue = (field) => {
        if (field === null || field === undefined) return "N/A"; // fallback
        return typeof field === "object" ? field?.value : field;
      };
  export function getMaxAlert (item) {
      const mapping = {
        Tilt: "tiltAngle",
        Shock: "shockThresh",
        Anymotion: "accelThresh",
      };
      const key = Object.keys(mapping).find((prefix) =>
        item?.name?.startsWith(prefix)
      );
      return key ? getValue(item?.[mapping[key]]) : getValue(item?.max);
    };

export function convertReelableBatteryValue(batteryValue) {
  if (batteryValue > 2700) {
    return "100";
  } else if (batteryValue > 1500) {
    const percentage = Math.round(((batteryValue - 1500) / 1200) * 100);
    return `${percentage}`;
  } else if (batteryValue > 100 && batteryValue <= 1500) {
    return "0";
  } else {
    return `${batteryValue}`;
  }
}
